// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__QJTar","errorLogs":"EditorFooter_errorLogs__3FasT"};